// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"0726a438","436":"229e1ae4","453":"f394a27d","501":"9c8d9baa","606":"2b75c2ac","821":"6c2dbfd4","925":"25ed5615","969":"54c2da6d"}[chunkId] + ".chunk.js";
};